export default "__VITE_ASSET__67f99f18__"